module.exports = __webpack_public_path__ + "img/exchange-rate.fc98b302.png";